'use client';

import { Typography } from '@bgzt/ui';

import { LinkByEnvironment, LogClick, LogImpression, ProductItem, ProductListTemp, Spacing } from '~/components';
import { PRODUCT_DETAIL_SNACKBAR_BOTTOM_OFFSET } from '~/app/products/[pid]/_components/constants';
import { RecommendProduct } from '~/apis/rec';
import { CONTENT_TYPE, EVENT_ACTION, EVENT_TYPE, PAGE_ID, VIEW_ID } from '~/apis/log/constant';

type Props = {
  pid: number;
  isPromotionBanner?: boolean;
  recommendProducts?: RecommendProduct[];
};

export const RecommendProducts = ({ pid, recommendProducts, isPromotionBanner = false }: Props) => {
  if (!recommendProducts) return null;

  return (
    <>
      <Spacing height={isPromotionBanner ? 24 : 30} />
      <Typography variant="S1" color="gray-900">
        이 상품과 비슷해요
      </Typography>

      <Spacing height={12} />
      <ProductListTemp col={3}>
        {recommendProducts?.map((recProduct, index) => {
          const path = `/products/${recProduct.pid}`;
          const logParams = {
            page_id: PAGE_ID.PRODUCT,
            view_id: VIEW_ID.RECOMMEND_PRODUCTS,
            page_label: pid.toString(),
            content_id: String(recProduct.pid),
            content_type: CONTENT_TYPE.MERCARI,
            content_position: index,
            tracking: recProduct?.tracking,
          };
          return (
            <li key={recProduct.pid}>
              <LogImpression
                params={{
                  ...logParams,
                  event_type: EVENT_TYPE.IMPRESSION,
                  event_action: EVENT_ACTION.IMPRESSION,
                }}
              >
                <LogClick
                  params={{
                    ...logParams,
                    event_type: EVENT_TYPE.SELECT_PRODUCT,
                    event_action: EVENT_ACTION.SELECT_PRODUCT,
                  }}
                >
                  <LinkByEnvironment href={path} target={'_self'}>
                    <ProductItem
                      key={recProduct.pid}
                      pid={Number(recProduct.pid)}
                      image={recProduct.productImage}
                      name={recProduct.productName}
                      location={recProduct.location}
                      updatedBefore={recProduct.updatedBefore}
                      price={recProduct.price}
                      status={'SELLING'}
                      faved={recProduct.isFavorite}
                      discountRate={recProduct.discount?.rate}
                      viewType="3-column"
                      snackbarBottomOffset={PRODUCT_DETAIL_SNACKBAR_BOTTOM_OFFSET}
                    />
                  </LinkByEnvironment>
                </LogClick>
              </LogImpression>
            </li>
          );
        })}
      </ProductListTemp>
    </>
  );
};
